<template>
  <div>
    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="v.assistantJob.$model"
          :errorMessages="getValidationErrorText(v.assistantJob)"
          label="Должность ВРИО"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.assistantRegNumber.$model"
          :errorMessages="getValidationErrorText(v.assistantRegNumber)"
          label="Регистрационный номер лица, сдавшего
квалификационный экзамен в Минюсте"
          outlined
          disabled
        />
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.assistantFirstName.$model"
          :errorMessages="getValidationErrorText(v.assistantFirstName)"
          label="Имя"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.assistantLastName.$model"
          :errorMessages="getValidationErrorText(v.assistantLastName)"
          label="Фамилия"
          outlined
          disabled
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.assistantPatronymic.$model"
          :errorMessages="getValidationErrorText(v.assistantPatronymic)"
          label="Отчество (при наличии)"
          outlined
          disabled
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';

export const assistantValidation = {
  assistantJob: {},
  assistantRegNumber: {},
  assistantFirstName: {},
  assistantLastName: {},
  assistantPatronymic: {},
};

export const assistantModel = {
  assistantJob: '',
  assistantRegNumber: '',
  assistantFirstName: '',
  assistantLastName: '',
  assistantPatronymic: '',
};

export default {
  name: 'Assistant',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
